/* -------------------------------------------------------------------------------------------------
 * HELPERS
 * -----------------------------------------------------------------------------------------------*/
const vivochaEngageChat = () => {
  if (window.vivochaEngageChat !== undefined) {
    window.vivochaEngageChat();
  } else {
    // eslint-disable-next-line no-console
    console.error('vivochaEngageChat is undefined');
  }
};
export { vivochaEngageChat };
